/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ChangePassword from 'components/ChangePassword';
import Cookies from 'js-cookie';
import Avatar from '@mui/material/Avatar';
import api from 'api';

import { GoChevronDown } from 'react-icons/go';
import { AiOutlineLogout, AiOutlineUser } from 'react-icons/ai';
import { IoWalletOutline } from 'react-icons/io5';
import { VscVmActive } from 'react-icons/vsc';
import { CgLock } from 'react-icons/cg';
import { BsBagCheck, BsShieldExclamation } from 'react-icons/bs';
import { Container, ContentArea, Logo, ContainerMenu } from './styles';
import { useHistory, useLocation } from 'react-router-dom';
import { secondary, white } from 'styles/colorProvider';
import { Dialog } from 'components';
import { useStoreActions, useStoreState } from 'easy-peasy';

function Header() {
  const history = useHistory();
  const location = useLocation();

  const [userData, setUserData] = useState({});

  const getUser = async () => {
    const userInfo = {
      method: 'GET',
      url: `/me`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      json: true,
    };
    const response = await api(userInfo);

    setUserData(response.data);
  };

  useEffect(() => getUser(), []);

  const [brokerPermission, setBrokerPermission] = [
    useStoreState(({ brokerPermission }) => brokerPermission.brokerPermission),
    useStoreActions(({ brokerPermission }) => brokerPermission.setBrokerPermission),
  ];

  const [backofficePermission, setBackofficePermission] = [
    useStoreState(({ backofficePermission }) => backofficePermission.backofficePermission),
    useStoreActions(({ backofficePermission }) => backofficePermission.setBackofficePermission),
  ];

  const handleInitial = async (e) => {
    e.preventDefault();
    history.push('/minhas-apolices');
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangePassword = () => {
    handleOpen();
  };

  const handleLogout = async () => {
    const auth = Cookies.get('splitrisk-authtoken');
    Cookies.remove('splitrisk-authtoken');
    Cookies.remove('splitrisk-acceptCookies');
    handleOpen();
    history.push('/');

    await api({
      method: 'POST',
      url: `/logout`,
      headers: {
        'Content-Type': 'application/json',
        authorization: auth,
      },
      data: {},
      json: true,
    });
  };

  const getPermission = async () => {
    const getBrokerPermission = await api({
      method: 'GET',
      url: `/has-feature`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
        feature: 'broker-area',
      },
      json: true,
    });
    setBrokerPermission(getBrokerPermission?.data);

    const getBackofficePermission = await api({
      method: 'GET',
      url: `/has-feature`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
        feature: 'splitrisk-master',
      },
      json: true,
    });
    setBackofficePermission(getBackofficePermission?.data);

    const menusPermission = await api({
      method: 'POST',
      url: `/has-features`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      data: {
        features: [
          'menu-propostas',
          'menu-apolices',
          'menu-reclamacoes',
          'menu-usuarios',
          'menu-corretores',
          'menu-sinistros',
          'menu-cancelamentos',
          'menu-configuracoes',
          'menu-financeiro',
          'menu-produtos-portal',
          'menu-dashboard',
          'menu-blacklist-portal',
          'atualizar-assistencia',
          'gerar-relatorio-mensal-backoffice',
        ],
      },
      json: true,
    });

    Cookies.set('splitrisk-backoffice-permissions', JSON.stringify(menusPermission?.data));
  };

  const handleOpen = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);

  useEffect(() => {
    handleClose();
  }, [open]);

  useEffect(() => !brokerPermission && getPermission(), [brokerPermission]);

  return (
    <>
      <Container>
        <ContentArea>
          <Logo onClick={handleInitial} />
          <ContainerMenu onClick={handleClick}>
            <Avatar
              style={{ marginRight: 5 }}
              sx={{ width: 30, height: 30, fontSize: 14, background: secondary }}
              src={userData?.signedUrl}
              image={userData?.signedUrl}
            />
            <GoChevronDown color={white} size={14} />
          </ContainerMenu>
        </ContentArea>
      </Container>
      <Menu
        style={{ marginTop: '50px', marginLeft: '-40px' }}
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {backofficePermission && (
          <MenuItem onClick={() => history.push('/backoffice/propostas')} dense>
            <VscVmActive size={18} style={{ marginRight: 10 }} />
            Portal backoffice
          </MenuItem>
        )}

        {/* {brokerPermission && (
          <MenuItem onClick={() => history.push('/area-do-corretor')} divider dense>
            <BsBagCheck size={17} style={{ marginRight: 11 }} />
            Portal do corretor
          </MenuItem>
        )} */}

        <MenuItem onClick={() => history.push('/meu-perfil')} dense>
          <AiOutlineUser style={{ marginRight: 10 }} />
          Meu perfil
        </MenuItem>

        {/* {!location.pathname.includes('/novo-sinistro') && (
          <MenuItem onClick={() => history.push('/novo-sinistro')} dense>
            <BsShieldExclamation style={{ marginRight: 10 }} />
            Comunicar sinistro
          </MenuItem>
        )} */}

        <MenuItem onClick={() => history.push('/minha-carteira')} dense>
          <IoWalletOutline style={{ marginRight: 10 }} />
          Minha carteira
        </MenuItem>

        <MenuItem onClick={handleChangePassword} dense>
          <CgLock style={{ marginRight: 10 }} />
          Alterar senha
        </MenuItem>

        <MenuItem onClick={handleLogout} dense>
          <AiOutlineLogout style={{ marginRight: 10 }} />
          Sair
        </MenuItem>
      </Menu>

      <Dialog open={open} onClose={handleCloseModal} title="Alterar senha">
        <ChangePassword handleCloseModal={handleCloseModal} />
      </Dialog>
    </>
  );
}

export default Header;
